import {
  IField_Astonish_Campaign_SendMode,
  IData_Astonish_Campaign_Network_Settings,
  IData_Astonish_Campaign_Config,
  IRecord_Astonish_Campaign_Core,
  IData_Astonish_Campaign_Summary,
  IRecord_Astonish_Email_Grouped_Status,
} from '../types/schema/astonish'

import {
  ASTONISH_CAMPAIGN_SENDMODE_NETWORK,
  ASTONISH_CAMPAIGN_DEFAULT_CRM_QUERY,
  ASTONISH_CAMPAIGN_DEFAULT_LAYOUT,
  ASTONISH_CAMPAIGN_STATUS_DRAFT,
  ASTONISH_EMAIL_STATUS,
  ASTONISH_EMAIL_STATUS_INFERENCE_MAP,
  ASTONISH_EMAIL_GROUPED_STATUS,
  ASTONISH_EMAIL_STATUS_GROUPS,
  ASTONISH_EMAIL_STATUS_LOST,
  ASTONISH_EMAIL_STATUS_SENT,
  ASTONISH_EMAIL_STATUS_BOUNCED,
  ASTONISH_EMAIL_STATUS_DELIVERED,
} from '../constants'

export const getDefaultNetwork = (
  mode: IField_Astonish_Campaign_SendMode,
  org?: string,
): IData_Astonish_Campaign_Network_Settings => {
  return {
    mode,
    org_ids: mode == ASTONISH_CAMPAIGN_SENDMODE_NETWORK ?
      [] : (org ? [org] : []),
  }
}

export const getDefaultConfig = (
  from_address?: string,
): IData_Astonish_Campaign_Config => {
  return {
    name: '',
    from_address: from_address || '',
    subject: '',
    notes: '',
  }
}

export const getDefaultData = (
  mode: IField_Astonish_Campaign_SendMode,
  org?: string,
  from_address?: string,
): Partial<IRecord_Astonish_Campaign_Core> => {
  return {
    status: ASTONISH_CAMPAIGN_STATUS_DRAFT,
    network: getDefaultNetwork(mode, org),
    config: getDefaultConfig(from_address),
    crm_query: ASTONISH_CAMPAIGN_DEFAULT_CRM_QUERY,
    layout: ASTONISH_CAMPAIGN_DEFAULT_LAYOUT,
  }
}

// some fields indicate other fields
// e.g. an email is "opened" state means it has been
// * scheduled
// * sent
// * delivered
// also
export const processEmailSummary = (
  summary: IData_Astonish_Campaign_Summary,
): IData_Astonish_Campaign_Summary => {
  const newSummaryData = Object.assign({}, summary.data)
  ASTONISH_EMAIL_STATUS.forEach(status => {
    const mapFields = ASTONISH_EMAIL_STATUS_INFERENCE_MAP[status]
    const originalValue = summary.data[status] || 0
    mapFields.forEach(mapStatus => {
      const existingValue = newSummaryData[mapStatus] || 0
      newSummaryData[mapStatus] = existingValue + originalValue
    })
  })
  ASTONISH_EMAIL_STATUS.forEach(status => {
    if(!newSummaryData[status]) newSummaryData[status] = 0
  })
  newSummaryData[ASTONISH_EMAIL_STATUS_LOST] = (newSummaryData[ASTONISH_EMAIL_STATUS_SENT] || 0) - (newSummaryData[ASTONISH_EMAIL_STATUS_DELIVERED] || 0) - (newSummaryData[ASTONISH_EMAIL_STATUS_BOUNCED] || 0)
  const ret: IData_Astonish_Campaign_Summary = Object.assign({}, summary, {
    data: newSummaryData,
  })
  return ret
}

export const groupEmailSummary = (
  summary: IData_Astonish_Campaign_Summary,
) => {
  return ASTONISH_EMAIL_GROUPED_STATUS.reduce<Partial<Record<IRecord_Astonish_Email_Grouped_Status, number>>>((all, field) => {
    const groups = ASTONISH_EMAIL_STATUS_GROUPS[field]
    const total = groups.reduce<number>((all, groupField) => {
      return all + (summary.data[groupField] || 0)
    }, 0)
    all[field] = total
    return all
  }, {})
}